// src/components/MatchCard.jsx
import React, { useState } from 'react';
import { Calendar, Clock, User, Send } from 'lucide-react';
import { format } from 'date-fns';
import styles from './MatchCard.module.css';

export default function MatchCard({ match, onSendOffer, loading = false, compact = false }) {
  const [showOfferForm, setShowOfferForm] = useState(false);
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  const startTime = new Date(match.start_time);
  const endTime = new Date(match.end_time);

  const handleSendOffer = async () => {
    setSending(true);
    try {
      await onSendOffer({
        customerId: match.customer_id,
        startTime: match.start_time,
        endTime: match.end_time,
        message,
      });
      setShowOfferForm(false);
      setMessage('');
    } catch (error) {
      console.error('Error sending offer:', error);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className={compact ? styles.cardCompact : styles.card}>
      {!compact && (
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <div className={styles.iconBadge}>
              <User size={20} aria-hidden="true" />
            </div>
            <div>
              <h3 className={styles.name}>{match.customer_name}</h3>
              <p className={styles.email}>{match.customer_email}</p>
            </div>
          </div>
          <span className={styles.pill}>Available</span>
        </div>
      )}

      <div className={styles.timeRows}>
        <div className={styles.timeRow}>
          <Calendar size={16} className={styles.timeRowIcon} aria-hidden="true" />
          <span style={{ fontWeight: 'var(--fw-medium)' }}>{format(startTime, 'EEEE, MMMM d, yyyy')}</span>
        </div>
        <div className={styles.timeRow}>
          <Clock size={16} className={styles.timeRowIcon} aria-hidden="true" />
          <span>
            {format(startTime, 'h:mm a')} – {format(endTime, 'h:mm a')}
            <span className={styles.duration}>({match.duration} min)</span>
          </span>
        </div>
      </div>

      {showOfferForm ? (
        <div className={styles.offerForm}>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Add a message for the customer (optional)"
            rows={3}
            className="form-input"
          />
          <div className={styles.offerFormActions}>
            <button
              onClick={() => setShowOfferForm(false)}
              disabled={sending}
              className={styles.btnCancel}
            >
              Cancel
            </button>
            <button
              onClick={handleSendOffer}
              disabled={sending}
              className={`btn-primary ${styles.btnSend}`}
            >
              {/* TODO(naming) inline send-proposal submit button */}
              {sending ? 'Sending…' : <><Send size={16} aria-hidden="true" /> Send Proposal</>}
            </button>
          </div>
        </div>
      ) : (
        <button
          onClick={() => setShowOfferForm(true)}
          disabled={loading}
          className={styles.btnOfferOpen}
        >
          <Send size={16} aria-hidden="true" />
          {/* TODO(naming) inline send-proposal trigger label */}
          Send Proposal
        </button>
      )}
    </div>
  );
}
